var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3"},[_c('router-link',{class:_vm.fullClassName,attrs:{"to":_vm.to}},[_c('div',{staticClass:"flex items-center justify-center lg:justify-start w-full"},[_c('i',{class:_vm.iconFullClassName}),_vm._v(" "),_c('span',{staticClass:"hidden lg:block w-full"},[_vm._t("default")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }